<template>
  <!-- :style="themeStyle" -->
  <div id="app" class="layout-page">
    <transition :name="transitionName">
      <router-view />
    </transition>
  </div>
</template>

<script>
import {
  linkWallet
} from "../public/static/linkWallet.js";
import Vue from "vue";
import { Tabbar, TabbarItem, Toast, Notify, Dialog } from "vant";
Vue.use(Tabbar).use(TabbarItem).use(Notify).use(Dialog);
import store from "./store.js";
import { wgxRaiseInit } from "@/request/api";
import { mapGetters } from "vuex";
export default {
  name: "App",
  components: {},
  data() {
    return {
      transitionName: "vux-pop-out",
    };
  },
  computed: {
    // 窗口宽度
    winWidth: function winWidth() {
      return window.innerWidth;
    },
    // 窗口高度
    winHeight: function winHeight() {
      return window.innerHeight;
    },
    //  ...mapGetters(["themeStyle"]),
  },
  created() {
    document.body.removeChild(document.getElementById("Loading"));

    this.mediaChange(this.winWidth);

    let _this = this;
    if (document.body.clientWidth > 750) {
      this.mediaChange(375);
    } else {
      this.mediaChange(this.winWidth);
    }
    window.onresize = function () {
      if (document.body.clientWidth > 750) {
        _this.mediaChange(375);
      } else {
        _this.mediaChange(_this.winWidth);
      }
    };
    function IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
    // this.$store.commit("isPcChange", IsPC());

    if (this.$cookies.get("lang")) {
      this.$i18n.locale = this.$cookies.get("lang");
    } else {
      // 初始化语言
      this.$cookies.set("lang", "zh_CN");
    }

    /* this.$store.commit('userInfoChange'); */
  },
  methods: {
    mediaChange(width) {
      let mediafontSize = width / (750 / 100);
      let mediaHtml = document.querySelector("html");

      mediaHtml.style.fontSize = mediafontSize + "px";
    },
  },
  mounted() {
    // linkWallet((bool, chainId, address) => {
    //   console.log(address, 'address');
    //   if (address == '' || address == null) {
    //     return   window.location.href='https://www.tpwallet.io/'
    
    //   }
    //   window.ethereum.on("accountsChanged", function (accounts) {
    //     localStorage.removeItem("zxy_sign");
    //     localStorage.removeItem("addr");
    //   })
    // })
    // let _this = this;
    // function getQueryString(name) {
    //   let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    //   let url = window.location.hash.split("?")[1].match(reg);
    //   // console.log(url)
    //   if (url != null) {
    //     return decodeURI(url[2]); //decodeURI() 函数可对 encodeURI() 函数编码过的 URI 进行解码。
    //   } else {
    //     return null;
    //   }
    // }

    // //获取用户余额
    // _this.$store.commit('updateUserBalance');
    // setInterval(res => {
    // 	_this.$store.commit('updateUserBalance');
    // }, 3000);
  },
  watch: {
    $route(to, from) {
      if (to.meta.index < from.meta.index) {
        this.transitionName = "vux-pop-out";
      } else {
        this.transitionName = "vux-pop-in";
      }
    },
  },
};
</script>

<style lang="scss">
// 引入全局的样式
@import "@/assets/scss/base.scss";
@import "@/assets/scss/app.scss";

// @media only screen and (min-width: 750px) {
// 	#app {
// 		max-width: 375px;
// 		position: absolute;
// 		left: 0;
// 		right: 0;
// 		margin: 0 auto;
// 	}
// }
.layout-page {
  // height: 100vh;
  font-size: 14px;
  // background: #0b0b2f;
  background: url("./assets/img/page/BG.png") no-repeat scroll;
  background-size: 100% 100%;
  background-position: center center;
  color: $text-color;
  // min-height: 100vh !important;
  height: 100% !important;
  // padding-bottom: 50px;
}

div::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 0px;
}

::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 0px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 0px;
}

body,
html,
#app {
  padding: 0;
  margin: 0 auto;
  height: 100%;
  position: relative;
  overflow-x: hidden;
}

body {
  font-size: 14px;
  // background-image: url(assets/img/bg.png);
  // background-image: linear-gradient(to right, #3f1e50, #051f3d);
  overflow-y: scroll;
  background-size: 100% 100%;
  height: 100%;
  background-color: #090101 !important;
}

// @media screen and (min-width: 750px) {
// 	body {
// 		background-image: url(assets/img/backPc.png);
// 		background-color: #ECEBE7;
// 		height: 100%;
// 		background-size: 100vw 100vh;
// 	}
// }

.fwbHtml {
  padding: 0.2rem;

  p {
    margin: 10px 0;
  }
}

//页面切换动画
.vux-pop-out-enter-active,
.vux-pop-out-leave-active,
.vux-pop-in-enter-active,
.vux-pop-in-leave-active {
  will-change: transform;
  transition: all 300ms;
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  backface-visibility: hidden;
  perspective: 1000;
}

.vux-pop-out-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

.vux-pop-out-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.vux-pop-in-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}

.vux-pop-in-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}

div {
  box-sizing: border-box;
}

.no_data {
  text-align: center;
  color: #666;
  font-size: 0.26rem;
  padding: 0.24rem 0;
  cursor: pointer;
}

.van-popover__arrow {
  left: 90% !important;
}

.van-popover {
  // left: 230px !important;
}

.allTit {
  font-family: "ElMessiri", KaiTi;
  font-size: 0.48rem;
  font-weight: 600;
  text-align: center;
  line-height: 0.8rem;
  color: #f4bf16;
  letter-spacing: 0.08rem;
  text-shadow: #8e5a00 1px 3px 2px;
  margin: 0.2rem 0;
}</style>
